export const COLUMN_DEFINITIONS = [
  { field: 'identifier', label: 'Identifier', width: 2 },
  { field: 'locale', label: 'State/Locale', width: 1 },
  { field: 'product_type', label: 'Product Type', width: 1 },
  { field: 'product_segment', label: 'Product Segment', width: 1 },
  { field: 'operating_company', label: 'Operating Company', width: 2 },
  { field: 'asset_type', label: 'Asset Type', width: 1 },
  { field: 'environment', label: 'Environment', width: 1 },
  {
    field: 'new_business_effective_date',
    label: 'New Business Effective Date',
    width: 1,
  },
  {
    field: 'renewal_effective_date',
    label: 'Renewal Effective Date',
    width: 1,
  },
  { field: 'bind_active_date', label: 'Active/Bind Date', width: 1 },
  { field: 'github_links', label: '', width: '60px' },
];

export const DEFAULT_PAGE_SIZE = 50;
